import { HttpErrorResponse } from '@angular/common/http';
import { FIRST_ELEMENT_INDEX } from '@modeso/aumico-lib-core-fe';
import { AnnualReportStep } from '@modeso/types__aumico-lib-annualreport-be';
import { createFeature, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import * as fromAnnualReportNavigationActions from '../actions/annual-report-navigation.actions';

export interface FeatureState {
    activeArNavigations: AnnualReportStep[];
    error: HttpErrorResponse | undefined;
}

export interface AppState {
    aumicoAnnualReportNavigation: FeatureState;
}

export const selectFeature = createFeatureSelector<FeatureState>('aumicoAnnualReportNavigation');

export const selectNextNavigation = (currentStep: AnnualReportStep) =>
    createSelector(selectFeature, (state: FeatureState) => {
        const index = state.activeArNavigations.indexOf(currentStep);
        if (index < FIRST_ELEMENT_INDEX && index >= state.activeArNavigations.length - 1) {
            return null;
        }

        // skipping balance and income account proof navigations
        if (
            state.activeArNavigations[index + 1] !== AnnualReportStep.BALANCE_ACCOUNT_PROOF &&
            state.activeArNavigations[index + 1] !== AnnualReportStep.INCOME_ACCOUNT_PROOF
        ) {
            return state.activeArNavigations[index + 1];
        } else {
            if (
                state.activeArNavigations[index + 2] === AnnualReportStep.BALANCE_ACCOUNT_PROOF ||
                state.activeArNavigations[index + 2] === AnnualReportStep.INCOME_ACCOUNT_PROOF
            ) {
                return state.activeArNavigations[index + 3];
            }

            return state.activeArNavigations[index + 2];
        }
    });

export const selectPreviousNavigation = (currentStep: AnnualReportStep) =>
    createSelector(selectFeature, (state: FeatureState) => {
        const index = state.activeArNavigations.indexOf(currentStep);
        // skipping balance and income account proof navigations
        if (
            state.activeArNavigations[index - 1] !== AnnualReportStep.BALANCE_ACCOUNT_PROOF &&
            state.activeArNavigations[index - 1] !== AnnualReportStep.INCOME_ACCOUNT_PROOF
        ) {
            return state.activeArNavigations[index - 1];
        } else {
            if (
                state.activeArNavigations[index - 2] === AnnualReportStep.BALANCE_ACCOUNT_PROOF ||
                state.activeArNavigations[index - 2] === AnnualReportStep.INCOME_ACCOUNT_PROOF
            ) {
                return state.activeArNavigations[index - 3];
            }

            return state.activeArNavigations[index - 2];
        }
    });

export const isPartOfArNavigation = (targetNavigation: AnnualReportStep) =>
    createSelector(selectFeature, (state: FeatureState) => {
        return state.activeArNavigations.includes(targetNavigation);
    });

// Selectors Declarations - END

// Reducer Declarations - START

export const initialState: FeatureState = {
    activeArNavigations: [],
    error: undefined,
};

const navigationReducer = createReducer(
    initialState,
    on(fromAnnualReportNavigationActions.setActiveArNavigations, (state: FeatureState, action) => ({
        ...state,
        activeArNavigations: action.payload,
    })),

    on(fromAnnualReportNavigationActions.resetActiveArNavigation, (state: FeatureState) => ({
        ...state,
        activeArNavigations: [],
        currentArNavigation: undefined,
    })),
);

export const navigationFeature = createFeature({
    name: 'aumicoAnnualReportNavigation',
    reducer: navigationReducer,
});

export const {
    name,
    reducer, // feature reducer
    selectActiveArNavigations,
    selectError,
} = navigationFeature;
